import React from "react";
import StylizedRadioGroup from "../../../misc/stylized-radio-group.component";
import moment from "moment";

const SkipMonthSelectFields = (props) => {
  const skipOneMonthOptionObject = (dateObject) => {
    return {
      label: (
        <div className="f14">
          <div className="bold">Skip One Month</div>
          <div>Due Date {moment(dateObject.SkippableDueDate).format("MM/DD/YYYY")}</div>
        </div>
      ),
      id: "skipOneMonthRadio",
      value: "false",
    };
  };

  const skipTwoMonthsOptionObject = (dateObjectOne, dateObjectTwo) => {
    return {
      label: (
        <div className="f14">
          <div className="bold">Skip Two Months</div>
          <div>
            {`Due Date ${moment(dateObjectOne.SkippableDueDate).format("MM/DD/YYYY")} and
            ${moment(dateObjectTwo.SkippableDueDate).format("MM/DD/YYYY")}`}
          </div>
        </div>
      ),
      id: "skipTwoMonthsRadio",
      value: "true",
    };
  };

  const options =
    props.skippableDueDates.length === 1
      ? [skipOneMonthOptionObject(props.skippableDueDates[0])]
      : [
          skipOneMonthOptionObject(props.skippableDueDates[0]),
          skipTwoMonthsOptionObject(props.skippableDueDates[0], props.skippableDueDates[1]),
        ];

  return (
    <StylizedRadioGroup
      title="Choose Payment to Skip"
      subtitle="Select which payment(s) to skip. There is a $35 fee per skipped payment."
      fieldGroupName="skipTwoMonths"
      radioOptions={options}
      thisForm={props.thisForm}
      change={props.change}
      includeHighlighting={true}
    />
  );
};

export default SkipMonthSelectFields;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/payment-forms/field-components/general/skip-month-select-fields.component.js